// Core
import React, { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

// Styles
import './styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from 'utils/fetch';
import { restAPIs } from 'utils/restAPIs';
import { useEffect } from 'react';

import Button from 'components/commonComponents/Button';

// icons

import validator from 'validator';
import InputField from 'components/commonComponents/InputField';

import EtisalatTerms from 'components/modals/EtisalatTerms';
import { APP_ID } from 'config/constants';
import { persistUser } from 'utils/auth';
import { ArrowRightOutlined, RedoOutlined } from '@ant-design/icons';
import { Alert } from 'antd';

const Etisalat = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentLang } = useSelector((store) => store.commonData);
  const [data, setData] = useState('');
  const { subId } = useParams();
  const [duration, setDuration] = useState('')
  const [terms, setTerms] = useState('')
  const [encryptedPhone, setEncryptedPhone] = useState('')
  const [orderId, setOrderId] = useState('')
  const [txnId, setTxnId] = useState('')
  const [packageId, setPackageId] = useState('')
  const [tokenGenerated, setTokenGenerated] = useState('')
  const [, setEncryptedPIN] = useState('')

  const [isLoading, setLoading] = useState(false);
  const [phoneData, setPhoneData] = useState('');
  const { phone } = phoneData;
  const [errorPhone, setErrorPhone] = useState('');
  const [inputSend, setInputSend] = useState(false);

  const [isLoadingPIN, setLoadingPIN] = useState(false);
  const [pinData, setPINData] = useState('');
  const { pin } = pinData;
  const [errorPIN, setErrorPIN] = useState('');

  const [isLoadingResendPIN, setLoadingResendPIN] = useState(false);
  const [isResend, setIsResend] = useState(false);
  const [openTerms, setOpenTerms] = useState(false)

  const [subDescription, setSubDescrip] = useState('');

  const [errorAlert, setErrorAlert] = useState({ msg: '', key: Math.random(), open: false, severity: '' })

  const [searchParams] = useSearchParams();
  const [referralCode, setreferralCode] = useState('')
  const [discountCode, setdiscountCode] = useState('')

  const showAlert = (msg, severity) => {
    setErrorAlert({ msg, key: Math.random(), open: true, severity });
    setTimeout(() => {
      setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
    }, 3000);
  };

  const fetchSubscriptions = async () => {
    setLoading(true)
    const formData = new FormData();
    formData.append('language', currentLang?.id)
    formData.append('appId', APP_ID)
    if (searchParams.get('refcode'))
      formData.append('refCode', searchParams.get('refcode'))
    if (searchParams.get('discountCode'))
      formData.append('discountCode', searchParams.get('discountCode'))
    const res = await fetchData(restAPIs.getSubscriptions(formData));
    const plans = Array.isArray(res?.info) ? res.info : [];
    for (let i = 0; i < plans.length; i++) {
      if (String(subId) === String(plans[i].subscriptionId)) {
        setData(plans[i])
        setDuration(plans[i].duration)
      }
    }
    setLoading(false)
  };

  useEffect(() => {
    setreferralCode(searchParams.get('refcode'))
    setdiscountCode(searchParams.get('discountCode'))
    fetchSubscriptions();
    fetchTerms();
    getPackageID();
  }, [currentLang, duration]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);
  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };

  const handleOnChange = (key) => (value) => {
    setErrorPhone({
      ...errorPhone,
      [key]: null
    });
    setPhoneData({
      ...phoneData,
      [key]: value
    });
  };

  const handleOnChangePIN = (key) => (value) => {
    setErrorPIN({
      ...errorPIN,
      [key]: null
    });
    setPINData({
      ...pinData,
      [key]: value
    });
  };

  const handleSubmitPhone = async () => {
    const errors = {
      phone: !phone || (!validator.isNumeric(phone) && 'Enter valid phone'),
    };
    setErrorPhone(errors);
    let isFormValid = Object.values(errors).every((item) => !item);
    if (!isFormValid) return;
    setLoading(true)
    const res = await fetchData(restAPIs.encryption(phone));
    if (res.status && res.statusCode === 200) {
      setEncryptedPhone(res.result)
      const formD = new FormData();
      formD.append('action', 'orderNow')
      formD.append('subscriptionId', subId)
      formD.append('appId', APP_ID)
      formD.append('paymentMethodId', '2')
      formD.append('credentials', phone)
      const res1 = await fetchData(restAPIs.subscriptionForm(formD));
      if (res1.statusCode == 200) {
        setOrderId(res1.orderId)
        const res2 = await fetchData(restAPIs.encryption(res1.orderId));
        if (res2.status && res2.statusCode === 200) {
          setTxnId(res2.result)
          const formData = new FormData();
          formData.append('action', 'addPhone')
          formData.append('msisdn', res.result)
          formData.append('packageId', packageId)
          formData.append('txnid', res2.result)
          formData.append('language', currentLang?.id)
          const result = await fetchData(restAPIs.simBilling(formData));
          if (result.result.includes("Invalid_MSISDN")) {
            setLoading(false)
            setErrorAlert({ msg: 'Please check your phone number.!', key: Math.random(), open: true, severity: 'error' });
            setTimeout(() => {
              setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
            }, 3000);
          }
          else if (result.result == "") {
            setLoading(false)
            setErrorAlert({ msg: 'Please check your phone number.!', key: Math.random(), open: true, severity: 'error' });
            setTimeout(() => {
              setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
            }, 3000);
          }
          else {
            setLoading(false)
            let token_generated = result.result.substring(result.result.indexOf('|') + 1)
            setTokenGenerated(token_generated)
            let inpSnd = inputSend
            setInputSend(!inpSnd)
          }

        }
        else {
          setLoading(false)
          showAlert('Something went wrong, Please try Again.!', 'error');
        }
      }
      else {
        setLoading(false)
        setErrorAlert({ msg: res1.errormessage, key: Math.random(), open: true, severity: 'error' });
        setTimeout(() => {
          setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
        }, 3000);
      }
    }
    else {
      setLoading(false)
      setErrorAlert({ msg: 'Something went wrong, Please try Again.!', key: Math.random(), open: true, severity: 'error' });
      setTimeout(() => {
        setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
      }, 3000);
    }

  }

  const handleSubmitPIN = async () => {
    const errors = {
      pin: !pin,
    };
    setErrorPIN(errors);
    let isFormValid = Object.values(errors).every((item) => !item);
    if (!isFormValid) return;
    setLoadingPIN(true)
    const res = await fetchData(restAPIs.encryption(pin));
    if (res.status && res.statusCode === 200) {
      setEncryptedPIN(res.result)
      const formData = new FormData();
      formData.append('action', 'addPin')
      formData.append('msisdn', encryptedPhone)
      formData.append('packageId', packageId)
      formData.append('txnid', txnId)
      formData.append('token', tokenGenerated)
      formData.append('pin', res.result)
      formData.append('phoneNumber', phone)
      formData.append('detxnId', orderId)
      formData.append('depackageId', (duration == 30) ? '2110' : '2111')
      formData.append('language', currentLang?.id)
      const result = await fetchData(restAPIs.simBilling(formData));
      if (result.statusCode === 200 && result.result.includes("invalidpin")) {
        setErrorAlert({ msg: 'Please enter a valid pin.!', key: Math.random(), open: true, severity: 'error' });
        setTimeout(() => {
          setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
        }, 3000);
        setLoadingPIN(false)
      }
      else if (result.statusCode === 200 && result.result.includes("expiredpin")) {
        setIsResend(true)
        setErrorAlert({ msg: 'Your pin has been expired.!', key: Math.random(), open: true, severity: 'warning' });
        setTimeout(() => {
          setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
        }, 3000);
        setLoadingPIN(false)
      }
      else if (result.statusCode !== 200) {
        setLoadingPIN(false)
        showAlert(result.errormessage || 'Something went wrong, Please try Again.!', 'error');
      }
      else {
        const formD = new FormData();
        formD.append('action', 'orderStatusUpdate')
        formD.append('orderId', orderId)
        formD.append('transactionStatusId', '1')
        formD.append('appId', APP_ID)
        formD.append('txnId', txnId)
        const resultSub = await fetchData(restAPIs.subscriptionForm(formD));
        setLoadingPIN(false)
        if (resultSub?.statusCode === 200) {
          persistUser(dispatch, resultSub);
          showAlert('Subscribed Successfully.!', 'success');
          navigate('/')
        }
        else {
          showAlert(resultSub?.errormessage || 'Your payment could not be confirmed. Please contact support.', 'error');
        }
      }
    }
    else {
      setLoadingPIN(false)
      setErrorAlert({ msg: 'Something went wrong, Please try Again.!', key: Math.random(), open: true, severity: 'error' });
      setTimeout(() => {
        setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
      }, 3000);
    }
  }

  const handleResendPIN = async () => {
    setLoadingResendPIN(true)
    const formData = new FormData();
    formData.append('action', 'addPhone')
    formData.append('msisdn', encryptedPhone)
    formData.append('packageId', packageId)
    formData.append('txnid', txnId)
    formData.append('language', currentLang?.id)
    const result = await fetchData(restAPIs.simBilling(formData));
    setLoadingResendPIN(false)
    if (result.result.includes("Invalid_MSISDN")) {
      setErrorAlert({ msg: 'Please check your phone number.!', key: Math.random(), open: true, severity: 'error' });
      setTimeout(() => {
        setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
      }, 3000);
    }
    else if (result.result == "") {
      setErrorAlert({ msg: 'Please check your phone number.!', key: Math.random(), open: true, severity: 'error' });
      setTimeout(() => {
        setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
      }, 3000);
    }
    else {
      let token_generated = result.result.substring(result.result.indexOf('|') + 1)
      setTokenGenerated(token_generated)
    }
  }

  const handleExit = () => {
    referralCode ? navigate('/subscription-payment/' + subId + '?refcode=' + referralCode) : discountCode ? navigate('/subscription-payment/' + subId + '?discountCode=' + discountCode) : navigate('/subscription-payment/' + subId);
  }

  const fetchTerms = async () => {
    const res = await fetchData(restAPIs.etisalatTerms(duration == 30 ? 54 : 55, currentLang?.id));
    setTerms(res.page.description)
    setSubDescrip(res.page.subDescription)
  }

  const getPackageID = async () => {
    const res = await fetchData(restAPIs.encryption(duration == 30 ? '2110' : '2111'));
    setPackageId(res.result)
  }

  const handleCloseTerms = () => {
    setOpenTerms(false)
  }

  const handleTerms = () => {
    setOpenTerms(true)
  }

  return (
    <>
      
      <div className='container __innerTopPad'>
      <h2 className='__common-head'> Etisalat</h2>
        <div className='row justify-content-center'>
          <div className='col-md-5 text-center'>
            <h3 style={{ fontSize: '20px' }}>{subDescription && subDescription}</h3>
            <p style={{ margin: 0 }}><b>{data?.duration}</b> days</p>
            <h5 style={{ margin: 0 }}>{data?.subscriptionName}</h5>
            <h2 style={{ margin: 0 }}>AED {data?.price}.00</h2>
            <p style={{ color: '#037e08' }}>{data?.descline1}</p>
            {!inputSend ? <>
              <div className='mb-4'>
                <InputField
                  type="number"
                  placeholder='Enter your mobile number (971******) to receive OTP'
                  label='Mobile Number'
                  value={phone}
                  onChange={handleOnChange('phone')}
                  error={errorPhone.phone}
                />
              </div>

              {errorAlert && errorAlert.open ?
                <div className='mb-3'>
                  <Alert type={errorAlert.severity || 'info'} showIcon message={errorAlert.msg} />

                </div>
                : ''}

              <Button
                label='Subscribe through PIN Code'
                icon={<ArrowRightOutlined />}
                handleOnClick={handleSubmitPhone}
                withLoader
                loading={isLoading}
                disabled={isLoading}
                style={{ backgroundColor: '#8bc34a' }}
              />
              <Button
                label='Exit'
                handleOnClick={handleExit}
                style={{ backgroundColor: '#000' }}
                className='mt-2 mb-4'
              />
            </> :
              <>
                <p style={{ fontSize: '20px', lineHeight: '1' }}>Please Enter the PIN Code you received to activate you subscription</p>
                <div className='mb-4'>
                  <InputField
                    type="number"
                    placeholder='Please Enter the PIN'
                    label='PIN Number'
                    value={pin}
                    onChange={handleOnChangePIN('pin')}
                    error={errorPIN.pin}
                  />
                </div>

                {errorAlert && errorAlert.open ?
                  <div className='mb-3'>
                    <Alert type={errorAlert.severity || 'info'} showIcon message={errorAlert.msg} />

                  </div>
                  : ''}


                <Button
                  label='Confirm your subscription'
                  icon={<ArrowRightOutlined />}
                  handleOnClick={handleSubmitPIN}
                  withLoader
                  loading={isLoadingPIN}
                  disabled={isLoadingPIN}
                  style={{ backgroundColor: '#8bc34a' }}
                />

                {isResend ? <Button
                  label='Resend PIN'
                  icon={<RedoOutlined />}
                  handleOnClick={handleResendPIN}
                  withLoader
                  loading={isLoadingResendPIN}
                  style={{ backgroundColor: '#777' }}
                  className='mt-2'
                /> : ''}

                <Button
                  label='Exit'
                  handleOnClick={handleExit}
                  style={{ backgroundColor: '#000' }}
                  className='mt-2 mb-4'
                />
              </>
            }

            <div className='terms_and_conditions'>
              <h1>Terms &amp; Conditions</h1>
              <p>By clicking on the above subscribe button, you will agree on the below terms and conditions:</p>
              <div className='__terms' dangerouslySetInnerHTML={{ __html: terms && terms }}></div>
              <div className='__terms'>
                <p>• For complete T&C <a onClick={handleTerms} style={{ fontWeight: 'bold', color: 'red', cursor: 'pointer' }}>Click here</a></p>
                <EtisalatTerms open={openTerms} onClose={handleCloseTerms} pageId={duration == 30 ? 54 : 55} />
              </div>
            </div >
          </div>
        </div>
      </div>
    </>
  );
};

export default Etisalat;